import { render, staticRenderFns } from "./tabs-layout.vue?vue&type=template&id=0b748e01&scoped=true"
import script from "./tabs-layout.vue?vue&type=script&lang=js"
export * from "./tabs-layout.vue?vue&type=script&lang=js"
import style0 from "./tabs-layout.vue?vue&type=style&index=0&id=0b748e01&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b748e01",
  null
  
)

export default component.exports